export default [
  {
    path: 'notices',
    title: '全部公告',
    docId: 'doc1'
  },
  {
    path: 'notices',
    title: '产品发布',
    docId: 'doc2'
  },
  {
    path: 'notices',
    title: '维护公告',
    docId: 'doc3'
  },
  {
    path: '/notices',
    title: '技术变更',
    docId: 'doc4'
  },
  {
    path: '/notices',
    title: '规则变更',
    docId: 'doc5'
  },
  {
    path: 'notices',
    title: '活动公告',
    docId: 'doc6'
  }
];
